import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kehuxixingpinggu",
  "use": "icon-kehuxixingpinggu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-kehuxixingpinggu\"><path d=\"M8.981 14H2.503a.5.5 0 01-.498-.5v-11a.5.5 0 01.498-.5h5.98v2.5a1 1 0 00.997 1h2.492v3a.5.5 0 10.997 0V4.222a.498.498 0 00-.146-.353l-2.698-2.722A.5.5 0 009.772 1H2.005a1 1 0 00-.997 1v12a1 1 0 00.997 1H8.98a.5.5 0 000-1zm.997-9.5A.5.5 0 019.48 4V2l2.492 2.5H9.978zm-3.426 6.016h-3.02a.5.5 0 000 1h3.02a.5.5 0 000-1zm2.959-3H3.53a.5.5 0 000 1h5.98a.5.5 0 000-1zm-5.988-2h2.991a.5.5 0 000-1h-2.99a.5.5 0 000 1zm7.786 8.323a.5.5 0 01-.498-.523l.094-1.982-2.416.763a.499.499 0 11-.3-.953l3.098-.978a.5.5 0 01.649.501l-.092 1.969 2.49-.83a.5.5 0 01.318.949l-3.182 1.06a.581.581 0 01-.16.024z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/kehuxixingpinggu.svg
// module id = 486
// module chunks = 4